import { ISignupFormValues } from '@models/ISignupFormValues';
import axios from 'axios';

const signupFormSubmit = async (
  { firstName, lastName, email, country, language, captcha }: ISignupFormValues,
  contactList: string,
  page: string,
  apiUrl: string,
  productCode?: string
) => {
  const newsletterBody = {
    locale: language,
    contactAddresses: [
      {
        nameFirst: firstName,
        nameLast: lastName,
        country: {
          iso2: country,
        },
      },
    ],
    contactEmails: [
      {
        email,
      },
    ],
    optinSubscriptions: [
      {
        subscribed: true,
      },
    ],
    ...(contactList
      ? {
          contactListContacts: [
            {
              contactList: {
                lookupName: contactList,
              },
            },
          ],
        }
      : {}),
  };

  const productBody = {
    firstName,
    lastName,
    email,
    languageCode: language,
    productCode,
    reCaptchaCode: captcha,
  };

  const headers = {
    'Content-Type': 'application/json',
    Accept: '*/*',
    'Accept-Encoding': 'gzip, deflate, br',
    Connection: 'keep-alive',
    'g-recaptcha-response': captcha,
    'X-Referer': page,
  };

  await axios.post(apiUrl, productCode ? productBody : newsletterBody, {
    headers,
  });
};

export default signupFormSubmit;
